function isTemplate(templateName) {
  return document.body.classList.contains(`template-${templateName}`);
}

if (isTemplate('index')) {

// Banner / Hero
$('.Index_banner_slider_main a').click(function() {
  var current_link = $(this).attr('href') || undefined;
  var current_title = $(this).text() || undefined;
  var section_type = $(this).closest('.Index_banner_slider_main').attr("section-type") || undefined;
  var banner_id = $(this).closest('.slideshow__slide').attr("banner-id") || undefined;

  window.dataLayer.push({
    event: "hp_click",
    click_type: 'Slide Button',
    component_name: section_type,
    component_id: banner_id,
    link_text: current_title,
    link_path: current_link,
    product_name: undefined,
    collection_name: undefined,
    slide_index: undefined,
    active_state: banner_id
  });
});

// Collection Carousel - Shop All Link
$('.Index_tab_collection_section_main .Index_tab_collection_section_shop_link a').click(function() {
  var current_link = $(this).attr('href') || undefined;
  var section_type = $(this).closest('.Index_tab_collection_section_main').attr('section-type') || undefined;
  var current_title = $(this).text() || undefined;
  var banner_id = $(this).attr('banner-id') || undefined;
  let activeState = $(this).parent().attr("data-collection-link") || undefined;

  window.dataLayer.push({
    event: "hp_click",
    click_type: 'Shop All Link',
    component_name: section_type,
    component_id: banner_id,
    link_text: current_title,
    link_path: current_link,
    product_name: undefined,
    collection_name: undefined,
    slide_index: undefined,
    active_state: activeState
  });
});

// Collection Carousel - Product Card Image + Text
$('.Index_tab_collection_section_main .product-card-wrapper a').click(function() {
  var current_link = $(this).attr('href') || undefined;
  var section_type = $(this).closest('.Index_tab_collection_section_main').attr('section-type') || undefined;
  var section_id = $(this).closest('.Index_tab_collection_section_main').attr('component-id') || undefined;
  var current_title = $(this).attr('link_text') || undefined;
  let activeState = $(".Index_tab_collection_section_left_tabs_single_tab.active")?.find("[data-collection-title]")?.attr("data-collection-title") || undefined;
  var productName = $(this).closest('.product-card-wrapper').attr("data-name");

  window.dataLayer.push({
    event: "hp_click",
    click_type: 'Product Card',
    component_name: section_type,
    component_id: section_id,
    link_text: current_title,
    link_path: current_link,
    product_name: productName,
    collection_name: undefined,
    slide_index: undefined,
    active_state: activeState
  });
});

// Collection Carousel - Product Card CTA
$('.Index_tab_collection_section_main .product-card-wrapper .quick-add__submit ').click(function() {
  var current_link = $(this).attr('href') || undefined;
  var section_type = $(this).closest('.Index_tab_collection_section_main').attr('section-type') || undefined;
  var section_id = $(this).closest('.Index_tab_collection_section_main').attr('component-id') || undefined;
  var current_title = $(this).text() || undefined;
  let activeState = $(".Index_tab_collection_section_left_tabs_single_tab.active")?.find("[data-collection-title]")?.attr("data-collection-title") || undefined;
  var productName = $(this).closest('.product-card-wrapper').attr("data-name");

  window.dataLayer.push({
    event: "hp_click",
    click_type: 'Product Card',
    component_name: section_type,    
    component_id: section_id,
    link_text: current_title,
    link_path: undefined,
    product_name: productName,
    collection_name: undefined,
    slide_index: undefined,
    active_state: activeState
  });
});
}

document.addEventListener("click", function({ target }) {
  // if(target.classList.contains("swiper-button-prev") || target.closest(".swiper-button-prev")) {
  //   const productCard = target.closest(".Card_product_main_new");
  //   const searchResultsWrapper = productCard?.closest(".search-results-wapper");
  //   console.log("Search Results Wrapper Found:", searchResultsWrapper);

  //   const slideItem = productCard.querySelector("[js-slide-item]");


  //   if(searchResultsWrapper) {
  //     const mediaPosition = slideItem.getAttribute("data-position");
  //     const alt = productCard.querySelector("img").getAttribute("alt");
  //     window.dataLayer.push({
  //       'event': "header_search",
  //       'click_type': 'product carousel', 
  //       'link_text': alt,
  //       'link_id': mediaPosition,
  //         'section': 'popular search',
  //         'search_term': undefined,
  //         'content_type': "header search product card",
  //         'content_group': "default"        
  //     });
  //   }
  // };

  // if(target.classList.contains("swiper-button-next") || target.closest(".swiper-button-next")) {
  //   const productCard = target.closest(".Card_product_main_new");
  //   const searchResultsWrapper = productCard?.closest(".search-results-wapper");
  //   console.log("Search Results Wrapper Found:", searchResultsWrapper);

  //   const slideItem = productCard.querySelector("[js-slide-item]");


  //   if(searchResultsWrapper) {
  //     const mediaPosition = slideItem.getAttribute("data-position");
  //     const alt = productCard.querySelector("img").getAttribute("alt");
  //     window.dataLayer.push({
  //       'event': "header_search",
  //       'click_type': 'product carousel', 
  //       'link_text': alt,
  //       'link_path': undefined,
  //       'section': 'popular search',
  //       'search_term': undefined,
  //       'content_type': "header search product card",
  //       'content_group': "default"        
  //     });
  //   }
  // };

  // if(target.classList.contains("quick-add__submit") || target.closest(".quick-add__submit")) {
  //   const productCard = target.closest(".Card_product_main_new");
  //   const searchResultsWrapper = productCard?.closest("predictive-search");

  //   if(searchResultsWrapper){
  //     window.dataLayer.push({
  //       'event': "header_search",
  //       'click_type': 'button', 
  //       'link_text': target.innerText.trim() || undefined,
  //       'link_path': undefined,
  //       'section': 'popular search',
  //       'search_term': undefined,
  //       'content_type': "header search product card",
  //       'content_group': "default"        
  //     });
  //   }
  // }

  if(target.tagName == "FACET-REMOVE" || target.closest("facet-remove")) {
    const field = target.closest("facet-remove") || target
    window.dataLayer.push({
      'event': "plp_click",
      'click_type': 'filter', 
      'link_text': field.querySelector("span")?.innerText.trim().replace(/\n/g, " ") || target.innerText.trim().replace(/\n/g, " "),
      link_path: undefined,
      link_id: undefined
    });
  }

  if(target.tagName == "BUTTON" && !target.classList.contains("search__button") && target.closest("predictive-search")) {
    const card = target.closest(".Card_product_main_new");
    window.dataLayer.push({
      'event': "header_search",
      'click_type': 'product_carousel', 
      'link_text': target.innerText.trim(),
      link_path: card?.querySelector("a")?.getAttribute("href") || undefined,
      section: "Predictive search",
      search_term: currentSearchTerm || "default",
      content_type: "product card",
      content_group: currentSearchTerm ? "search results" : "default",
      product_name: card.getAttribute("data-product-title") ? card.getAttribute("data-product-title") : ""
    });
  }

  if (target.tagName === "A" && target.classList.contains("cart-item__link")) {
    const cartItem = target.closest(".cart-item");
    const cartName = cartItem?.querySelector(".cart-item__name");
    window.dataLayer.push({
      event: "slide_cart_click",
      click_type: "product_image",
      link_text: cartName?.innerText || undefined,
      link_path: target?.getAttribute('href') || undefined,
      link_id: "line_item"
    });
  };
  
  if (target.tagName === "A" && target.classList.contains("cart-item__name")) {
    const cartItem = target.closest(".cart-item");
    const cartName = cartItem?.querySelector(".cart-item__name");
    window.dataLayer.push({
      event: "slide_cart_click",
      click_type: "product_link",
      link_text: cartName?.innerText || undefined,
      link_path: target?.getAttribute('href') || undefined,
      link_id: "line_item"
    });
  };

  if (target.classList.contains("swiper-button-next") || target.closest(".swiper-button-next")) {
    const predictiveSearch = target.closest("predictive-search");
    if(predictiveSearch) {
      const card = target.closest(".Card_product_main_new");
      const activeSlide = card?.querySelector(".swiper-slide-active");
      const mediaPosition = parseInt(activeSlide?.getAttribute("data-swiper-slide-index")) + 1;
      const alt = activeSlide.querySelector("img").getAttribute("alt") || card?.querySelector("[js-product-title]").innerText;
      window.dataLayer.push({
          'event': "header_search",
          'click_type': 'product_carousel', 
          'link_text': alt,
          'link_id': mediaPosition,
          search_term: currentSearchTerm || "default",
          content_type: "product card",
          content_group: currentSearchTerm ? "search results" : "default",
          product_name: card.getAttribute("data-product-title") ? card.getAttribute("data-product-title") : ""
      });
    }
  };

  if (target.classList.contains("swiper-button-prev") || target.closest(".swiper-button-prev")) {
    const predictiveSearch = target.closest("predictive-search");
    if(predictiveSearch) {
      const card = target.closest(".Card_product_main_new");
      const activeSlide = card?.querySelector(".swiper-slide-active");
      const mediaPosition = parseInt(activeSlide?.getAttribute("data-swiper-slide-index")) + 1;
      const alt = activeSlide.querySelector("img").getAttribute("alt") || card?.querySelector("[js-product-title]").innerText;

      window.dataLayer.push({
          'event': "header_search",
          'click_type': 'product_carousel', 
          'link_text': alt,
          'link_id': mediaPosition,
          search_term: currentSearchTerm || "default",
          content_type: "product card",
          content_group: currentSearchTerm ? "search results" : "default",
          product_name: card.getAttribute("data-product-title") ? card.getAttribute("data-product-title") : ""
      });
    }
  };
})  



const predictiveSearchForms = document.querySelectorAll("[js-predictive-search-form]");
if(predictiveSearchForms.length) {
  predictiveSearchForms.forEach(predictiveSearchForm => {
    predictiveSearchForm.addEventListener('submit', function(evt) {
      const predictiveSearchField = this.querySelector("[js-predictive-search-field]");
      const searchTerm = predictiveSearchField.value;
      window.dataLayer.push({
        event: "header_search",
        click_type: undefined,
        link_text: searchTerm,
        link_path: undefined,
        search_term: searchTerm,
        content_type: "header predictive search",
        content_group: "search results",
      });
    })
  })
}